//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './CaseClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetCasesCaseQueryParameters = {
  patientId?: number | null | undefined ;
  ids?: number[] | null | undefined ;
  importIds?: string[] | null | undefined ;
  number?: string[] | null | undefined ;
  numberSource?: Types.NumberSource | null | undefined ;
  values?: { [key: string]: string[]; } | null | undefined ;
  includeValues?: boolean | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export type GetCaseCaseQueryParameters = {
  id: number ;
}

export type EditCaseCaseQueryParameters = {
  id: number ;
}

export type RemoveCaseCaseQueryParameters = {
  id: number ;
}

export type ReopenCaseCaseQueryParameters = {
  id: number ;
}

export function getCasesUrl(patientId?: number | null | undefined, ids?: number[] | null | undefined, importIds?: string[] | null | undefined, number?: string[] | null | undefined, numberSource?: Types.NumberSource | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/cases?";
if (patientId !== undefined && patientId !== null)
    url_ += "PatientId=" + encodeURIComponent("" + patientId) + "&";
if (ids !== undefined && ids !== null)
    ids && ids.forEach(item => { url_ += "Ids=" + encodeURIComponent("" + item) + "&"; });
if (importIds !== undefined && importIds !== null)
    importIds && importIds.forEach(item => { url_ += "ImportIds=" + encodeURIComponent("" + item) + "&"; });
if (number !== undefined && number !== null)
    number && number.forEach(item => { url_ += "Number=" + encodeURIComponent("" + item) + "&"; });
if (numberSource !== undefined && numberSource !== null)
    url_ += "NumberSource=" + encodeURIComponent("" + numberSource) + "&";
if (values !== undefined && values !== null)
    values && Object.keys(values).forEach(key => { url_ += encodeURIComponent(key) +"=" + encodeURIComponent("" + values[key]) + "&"; });
if (includeValues === null)
    throw new Error("The parameter 'includeValues' cannot be null.");
else if (includeValues !== undefined)
    url_ += "IncludeValues=" + encodeURIComponent("" + includeValues) + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getCasesDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfCaseListDto, unknown, Types.PageableListDtoOfCaseListDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfCaseListDto, unknown, Types.PageableListDtoOfCaseListDto>, 'queryFn'>> = {
};
export function getGetCasesDefaultOptions() {
  return getCasesDefaultOptions;
};
export function setGetCasesDefaultOptions(options: typeof getCasesDefaultOptions) {
  getCasesDefaultOptions = options;
}

export function getCasesQueryKey(dto: GetCasesCaseQueryParameters): QueryKey;
export function getCasesQueryKey(patientId?: number | null | undefined, ids?: number[] | null | undefined, importIds?: string[] | null | undefined, number?: string[] | null | undefined, numberSource?: Types.NumberSource | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getCasesQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { patientId, ids, importIds, number, numberSource, values, includeValues, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetCasesCaseQueryParameters;

    return trimArrayEnd([
        'CaseClient',
        'getCases',
        patientId as any,
        ids as any,
        importIds as any,
        number as any,
        numberSource as any,
        values as any,
        includeValues as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'CaseClient',
        'getCases',
        ...params
      ]);
  }
}
export function __getCases(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getCases(
      context.queryKey[2] as number | null | undefined,       context.queryKey[3] as number[] | null | undefined,       context.queryKey[4] as string[] | null | undefined,       context.queryKey[5] as string[] | null | undefined,       context.queryKey[6] as Types.NumberSource | null | undefined,       context.queryKey[7] as { [key: string]: string[]; } | null | undefined,       context.queryKey[8] as boolean | undefined,       context.queryKey[9] as number | undefined,       context.queryKey[10] as number | undefined,       context.queryKey[11] as string | null | undefined,       context.queryKey[12] as Types.SortDirection | undefined,       context.queryKey[13] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetCasesQuery<TSelectData = Types.PageableListDtoOfCaseListDto, TError = unknown>(dto: GetCasesCaseQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfCaseListDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets all cases.
 * @param patientId (optional) 
 * @param ids (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param numberSource (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetCasesQuery<TSelectData = Types.PageableListDtoOfCaseListDto, TError = unknown>(patientId?: number | null | undefined, ids?: number[] | null | undefined, importIds?: string[] | null | undefined, number?: string[] | null | undefined, numberSource?: Types.NumberSource | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfCaseListDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetCasesQuery<TSelectData = Types.PageableListDtoOfCaseListDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfCaseListDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let patientId: any = undefined;
  let ids: any = undefined;
  let importIds: any = undefined;
  let number: any = undefined;
  let numberSource: any = undefined;
  let values: any = undefined;
  let includeValues: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ patientId, ids, importIds, number, numberSource, values, includeValues, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetCasesCaseQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [patientId, ids, importIds, number, numberSource, values, includeValues, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfCaseListDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getCases(context, axiosConfig) : __getCases,
    queryKey: getCasesQueryKey(patientId, ids, importIds, number, numberSource, values, includeValues, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getCasesDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfCaseListDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets all cases.
 * @param patientId (optional) 
 * @param ids (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param numberSource (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetCasesData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfCaseListDto | undefined) => Types.PageableListDtoOfCaseListDto, patientId?: number | null | undefined, ids?: number[] | null | undefined, importIds?: string[] | null | undefined, number?: string[] | null | undefined, numberSource?: Types.NumberSource | null | undefined, values?: { [key: string]: string[]; } | null | undefined, includeValues?: boolean | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getCasesQueryKey(patientId, ids, importIds, number, numberSource, values, includeValues, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Gets all cases.
 * @param patientId (optional) 
 * @param ids (optional) 
 * @param importIds (optional) 
 * @param number (optional) 
 * @param numberSource (optional) 
 * @param values (optional) Example:
?values[f1__gr]=1&values[f1__le]=123&values[f2]=value.
Key is field name, IList<string> contain values. It's an IList because we support multiple values for 'eq' condition
See https://dev.azure.com/prismacode/Unicorn/_wiki/wikis/Unicorn.wiki/1490/DataBlocks-API for more details
 * @param includeValues (optional) If this flag is true, response DTO contains Values.
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetCasesDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfCaseListDto | undefined) => Types.PageableListDtoOfCaseListDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createCaseUrl(): string {
  let url_ = getBaseUrl() + "/api/cases";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createCaseMutationKey(): MutationKey {
  return trimArrayEnd([
      'CaseClient',
      'createCase',
    ]);
}

/**
 * Creates a case.
 * @param newCase Request parameter
 */
export function useCreateCaseMutation<TContext>(options?: Omit<UseMutationOptions<Types.CaseDto, unknown, Types.CreateCaseDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.CaseDto, unknown, Types.CreateCaseDto, TContext> {
  const key = createCaseMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (newCase: Types.CreateCaseDto) => Client.createCase(newCase),
    mutationKey: key,
  });
}
  
export function getCaseUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/cases/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getCaseDefaultOptions: Omit<UseQueryOptions<Types.CaseDto, unknown, Types.CaseDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.CaseDto, unknown, Types.CaseDto>, 'queryFn'>> = {
};
export function getGetCaseDefaultOptions() {
  return getCaseDefaultOptions;
};
export function setGetCaseDefaultOptions(options: typeof getCaseDefaultOptions) {
  getCaseDefaultOptions = options;
}

export function getCaseQueryKey(id: number): QueryKey;
export function getCaseQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetCaseCaseQueryParameters;

    return trimArrayEnd([
        'CaseClient',
        'getCase',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'CaseClient',
        'getCase',
        ...params
      ]);
  }
}
export function __getCase(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getCase(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetCaseQuery<TSelectData = Types.CaseDto, TError = unknown>(dto: GetCaseCaseQueryParameters, options?: Omit<UseQueryOptions<Types.CaseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a case by id.
 * @param id The case id.
 */
export function useGetCaseQuery<TSelectData = Types.CaseDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.CaseDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetCaseQuery<TSelectData = Types.CaseDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.CaseDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetCaseCaseQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.CaseDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getCase(context, axiosConfig) : __getCase,
    queryKey: getCaseQueryKey(id),
    ...getCaseDefaultOptions as unknown as Omit<UseQueryOptions<Types.CaseDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a case by id.
 * @param id The case id.
 */
export function setGetCaseData(queryClient: QueryClient, updater: (data: Types.CaseDto | undefined) => Types.CaseDto, id: number) {
  queryClient.setQueryData(getCaseQueryKey(id),
    updater
  );
}

/**
 * Gets a case by id.
 * @param id The case id.
 */
export function setGetCaseDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.CaseDto | undefined) => Types.CaseDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editCaseUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/cases/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editCaseMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'CaseClient',
      'editCase',
      id as any,
    ]);
}

/**
 * Edits a case.
 * @param id The case id.
 * @param updatedCase Request parameter
 */
export function useEditCaseMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.PatchCaseDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.PatchCaseDto, TContext> {
  const key = editCaseMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (updatedCase: Types.PatchCaseDto) => Client.editCase(id, updatedCase),
    mutationKey: key,
  });
}
  
type EditCase__MutationParameters = EditCaseCaseQueryParameters & {
  updatedCase: Types.PatchCaseDto;
}

/**
 * Edits a case.
 * @param id The case id.
 * @param updatedCase Request parameter
 */
export function useEditCaseMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, EditCase__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditCaseCaseQueryParameters}): UseMutationResult<void, unknown, EditCase__MutationParameters, TContext> {
  const key = editCaseMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: EditCase__MutationParameters) => Client.editCase(data.id ?? options?.parameters?.id!, data.updatedCase),
  mutationKey: key,
});
}
  
export function removeCaseUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/cases/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeCaseMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'CaseClient',
      'removeCase',
      id as any,
    ]);
}

/**
 * Removes a case.
 * @param id The case id.
 */
export function useRemoveCaseMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeCaseMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeCase(id),
    mutationKey: key,
  });
}
  
type RemoveCase__MutationParameters = RemoveCaseCaseQueryParameters

/**
 * Removes a case.
 * @param id The case id.
 */
export function useRemoveCaseMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemoveCase__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveCaseCaseQueryParameters}): UseMutationResult<void, unknown, RemoveCase__MutationParameters, TContext> {
  const key = removeCaseMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveCase__MutationParameters) => Client.removeCase(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function reopenCaseUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/cases/{id}/reopen";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function reopenCaseMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'CaseClient',
      'reopenCase',
      id as any,
    ]);
}

/**
 * Changes case status to normal.
 * @param id The case id.
 */
export function useReopenCaseMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = reopenCaseMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.reopenCase(id),
    mutationKey: key,
  });
}
  
type ReopenCase__MutationParameters = ReopenCaseCaseQueryParameters

/**
 * Changes case status to normal.
 * @param id The case id.
 */
export function useReopenCaseMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, ReopenCase__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: ReopenCaseCaseQueryParameters}): UseMutationResult<void, unknown, ReopenCase__MutationParameters, TContext> {
  const key = reopenCaseMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: ReopenCase__MutationParameters) => Client.reopenCase(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}